module.exports = __webpack_public_path__ + "img/mockup-islekter-home.e11cab6.png";